<section
  class="flex h-full w-full flex-col overflow-hidden bg-white text-gray-900"
  role="dialog"
  [attr.aria-label]="'board_v3_lead_conversion_title' | translate"
>
  <header class="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-3">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
      <app-icon>call_split</app-icon>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-base font-bold leading-6 text-gray-900">{{ 'board_v3_lead_conversion_title' | translate }}</h2>
      @if (isBulkMode) {
        <p class="m-0 truncate text-sm leading-5 text-gray-500">
          {{ 'board_v3_lead_conversion_selected_count' | translate: { count: selectedCardsCount } }}
        </p>
      }
    </div>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="'close' | translate"
      (click)="cancel()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto px-4 py-4">
    @if (step === 'action') {
      <div class="mb-3 flex items-center gap-2 text-xs font-semibold uppercase text-gray-400">
        <span class="flex h-6 w-6 items-center justify-center rounded-full bg-blue-50 text-blue-600">1</span>
        <span>{{ 'board_v3_lead_conversion_action_step' | translate }}</span>
      </div>

      @for (item of actions; track item.title) {
        <button
          type="button"
          class="mb-2 flex w-full min-w-0 items-center gap-3 rounded-lg border border-blue-100 bg-blue-50 px-3 py-3 text-left last:mb-0"
          [class.hover:bg-blue-100]="!item.disabled"
          [class.opacity-50]="item.disabled"
          [class.cursor-not-allowed]="item.disabled"
          [disabled]="item.disabled"
          (click)="item.action()"
        >
          <app-icon class="shrink-0 text-blue-600">{{ item.icon }}</app-icon>
          <span class="min-w-0 flex-1">
            <span class="block truncate text-sm font-semibold text-gray-900">
              {{ item.title | translate }}
            </span>
          </span>
          <app-icon class="shrink-0 text-blue-500">chevron_right</app-icon>
        </button>
      }
    } @else {
      <div class="mb-3 flex items-center gap-2 text-xs font-semibold uppercase text-gray-400">
        <span class="flex h-6 w-6 items-center justify-center rounded-full bg-blue-50 text-blue-600">2</span>
        <span>{{ 'board_v3_lead_conversion_funnel_step' | translate }}</span>
      </div>

      @if (hasDealFunnels) {
        <app-select
          [formControl]="dealFunnelControl"
          [options]="dealFunnels"
          [optionLabel]="'name'"
          [optionValue]="'id'"
          [filter]="true"
          [fluid]="true"
          [label]="'lead_target_deal_funnel'"
          [placeholder]="'lead_target_deal_funnel_placeholder' | translate"
          [loading]="isLoading"
        />
      } @else {
        <div class="flex min-h-32 flex-col items-center justify-center rounded-lg bg-gray-50 px-4 py-6 text-center">
          <app-icon class="mb-2 text-gray-300">account_tree</app-icon>
          <p class="m-0 text-sm font-medium text-gray-600">{{ 'board_v3_lead_conversion_no_deal_funnels' | translate }}</p>
        </div>
      }
    }
  </div>

  <footer class="flex shrink-0 items-center justify-between gap-3 border-t border-gray-100 px-4 py-3">
    @if (step === 'funnel') {
      <app-button [btnType]="'stroked'" (onChangeClick)="backToAction()">
        <span class="flex items-center gap-1"><app-icon>chevron_left</app-icon>{{ 'back' | translate }}</span>
      </app-button>
      <div class="ml-auto flex items-center gap-2">
        <app-button [btnType]="'cancel'" (onChangeClick)="cancel()">{{ 'cancel' | translate }}</app-button>
        <app-button [disabled]="isLoading || !hasDealFunnels || dealFunnelControl.invalid" (onChangeClick)="confirm()">
          {{ 'board_v3_lead_conversion_confirm' | translate }}
        </app-button>
      </div>
    } @else {
      <app-button class="ml-auto" [btnType]="'cancel'" (onChangeClick)="cancel()">{{ 'cancel' | translate }}</app-button>
    }
  </footer>
</section>
